import { TranslationFn } from '@/hooks/useTranslator';
import { Field, FieldType, isMarkdown } from '@/types/fields';

export const translateField = <T>(tr: TranslationFn, untranslatedField: Field<T>): Field<T> => {
  const description =
    untranslatedField.description && !isMarkdown(untranslatedField.description)
      ? tr(untranslatedField.description)
      : undefined;

  switch (untranslatedField.type) {
    case FieldType.boolean:
    case FieldType.multipleValues:
      return {
        ...untranslatedField,
        description: description,
        help: untranslatedField.help ? tr(untranslatedField.help) : undefined,
      };
    case FieldType.embedded:
    case FieldType.composite:
    case FieldType.list:
      return {
        ...untranslatedField,
        label: tr(untranslatedField.label),
        title: tr(untranslatedField.title ?? ''),
        description: description,
        help: untranslatedField.help ? tr(untranslatedField.help) : undefined,
        fields: untranslatedField.fields.map(
          (field: Field<unknown>): Field<unknown> => translateField(tr, field),
        ),
      };
    default:
      return {
        ...untranslatedField,
        label: tr(untranslatedField.label),
        title: tr(untranslatedField.title ?? ''),
        description: description,
        help: untranslatedField.help ? tr(untranslatedField.help) : undefined,
      };
  }
};
